import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';

export { default as Input } from './Input.vue';
export type { InputProps } from './Input.vue';
export { default as SearchBar } from './SearchBar.vue';

export const inputVariants = cva('text-xs', {
  defaultVariants: {
    size: 'default',
    variant: 'default',
  },
  variants: {
    size: {
      default: 'h-9 text-xs',
      lg: 'h-10 text-sm',
      sm: 'h-8 text-xs',
      xl: 'h-12 text-sm',
    },
    variant: {
      default: '',
      underline:
        'border-0 border-b rounded-none shadow-none px-1 focus-visible:ring-0 focus-visible:border-ring w-auto min-w-6 max-w-58 [field-sizing:content]',
    },
  },
});

export type InputVariants = VariantProps<typeof inputVariants>;
